const MODULE_LOAD_ERROR_MESSAGES = [
  'Importing a module script failed', // Safari/WebKit
  'dynamically imported module', // Chrome/Chromium and Firefox
  'is not a valid JavaScript MIME type', // MIME type mismatch (server returned HTML instead of JS)
  'MIME type', // Generic MIME type errors
  'Failed to fetch dynamically imported module', // Network/fetch failures for dynamic imports
]

export function isModuleLoadError(error: unknown): error is Error {
  if (!(error instanceof Error)) return false

  // Check for known error message patterns
  const hasKnownErrorMessage = MODULE_LOAD_ERROR_MESSAGES.some((msg) => error.message.includes(msg))
  if (hasKnownErrorMessage) return true

  // Check for TypeError with MIME type issues (common in production when stale HTML is returned)
  if (error instanceof TypeError && error.message.includes('text/html')) return true

  return false
}

export function getReloadCount(error: Error): number {
  return Number(sessionStorage.getItem(`reloadCount:${error.message}`))
}

export function incrementReloadCount(error: Error): void {
  const currentCount = getReloadCount(error)
  sessionStorage.setItem(`reloadCount:${error.message}`, String(currentCount + 1))
}
